<div
  class="info flex items-start rounded-[6px] p-[10px]"
  [ngClass]="{
    '!bg-primary-800': type() === InfoTypeEnum.INFO,
    '!bg-green-800': type() === InfoTypeEnum.SUCCESS,
    '!bg-yellow-800': type() === InfoTypeEnum.WARNING,
    '!bg-red-800': type() === InfoTypeEnum.ERROR,
  }"
>
  <div class="mr-[10px] flex items-center">
    <svg
      class="h-[22px] w-[22px]"
      [ngClass]="{
        '!fill-primary-500': type() === InfoTypeEnum.INFO,
        '!fill-green-500': type() === InfoTypeEnum.SUCCESS,
        '!fill-yellow-500': type() === InfoTypeEnum.WARNING,
        '!fill-red-500': type() === InfoTypeEnum.ERROR,
      }"
    >
      <use [attr.xlink:href]="'#' + type().toLowerCase()"></use>
    </svg>
  </div>
  <p
    class="info__text text-base-100 highlighted mx-[0] my-[auto] text-[12px] leading-[16px]"
    [innerHTML]="text()"
  ></p>
</div>
